{
  "metadata": {
    "id": "catppuccin-dark",
    "name": "Catppuccin",
    "description": "Портировано из темы «Catppuccin» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "catppuccin.json",
      "project": "catppuccin",
      "url": "https://github.com/catppuccin/catppuccin",
      "upstreamFile": "packages/ui/src/theme/themes/catppuccin.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.477,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 25.5,
      "syntaxVsTextMinDeltaE": 22.5,
      "chartsMinDeltaE": 24.2,
      "textSeparationDeltaE": 18.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#b4befe",
      "hover": "#bdc6fe",
      "active": "#c3cbfe",
      "foreground": "#000000",
      "muted": "#b4befe80",
      "emphasis": "#b4befe"
    },
    "surface": {
      "background": "#1e1e2e",
      "foreground": "#cdd6f4",
      "muted": "#303142",
      "mutedForeground": "#9ea4b9",
      "elevated": "#383a4c",
      "elevatedForeground": "#cdd6f4",
      "raised": "#4e5165",
      "raisedForeground": "#cdd6f4",
      "overlay": "#1e1e2ecc",
      "subtle": "#272839"
    },
    "interactive": {
      "border": "#515468",
      "borderHover": "#4f5265",
      "borderFocus": "#b4befe",
      "selection": "#cdd6f429",
      "selectionForeground": "#cdd6f4",
      "focus": "#b4befe59",
      "focusRing": "#b4befe61",
      "cursor": "#cdd6f4",
      "hover": "#cdd6f41c",
      "active": "#cdd6f429"
    },
    "status": {
      "error": "#f38ba8",
      "errorForeground": "#000000",
      "errorBackground": "#f38ba824",
      "errorBorder": "#f38ba873",
      "warning": "#f4b8e4",
      "warningForeground": "#000000",
      "warningBackground": "#f4b8e424",
      "warningBorder": "#f4b8e473",
      "success": "#a6d189",
      "successForeground": "#000000",
      "successBackground": "#a6d18924",
      "successBorder": "#a6d18973",
      "info": "#89dceb",
      "infoForeground": "#000000",
      "infoBackground": "#89dceb24",
      "infoBorder": "#89dceb73"
    },
    "pr": {
      "open": "#a6d189",
      "draft": "#abafc2",
      "blocked": "#f4b8e4",
      "merged": "#f38ba8",
      "closed": "#f38ba8"
    },
    "syntax": {
      "base": {
        "background": "#3f4154",
        "foreground": "#cdd6f4",
        "comment": "#acaebc",
        "keyword": "#cba6f7",
        "string": "#32db43",
        "number": "#fab387",
        "function": "#89b4fa",
        "variable": "#cdd6f4",
        "type": "#ffc814",
        "operator": "#b7d5c0"
      },
      "tokens": {
        "commentDoc": "#acaebc",
        "stringEscape": "#b7d5c0",
        "keywordImport": "#cba6f7",
        "storageModifier": "#cba6f7",
        "functionCall": "#89b4fa",
        "method": "#89b4fa",
        "variableProperty": "#89b4fa",
        "variableOther": "#cdd6f4",
        "variableGlobal": "#fab387",
        "variableLocal": "#b7d5c0",
        "parameter": "#cdd6f4",
        "constant": "#fab387",
        "class": "#ffc814",
        "className": "#ffc814",
        "interface": "#ffc814",
        "struct": "#ffc814",
        "enum": "#ffc814",
        "typeParameter": "#ffc814",
        "namespace": "#ffc814",
        "module": "#cba6f7",
        "tag": "#cba6f7",
        "jsxTag": "#cba6f7",
        "tagAttribute": "#89b4fa",
        "tagAttributeValue": "#32db43",
        "boolean": "#fab387",
        "decorator": "#cba6f7",
        "label": "#89b4fa",
        "regexp": "#32db43"
      }
    },
    "charts": {
      "series": [
        "#b4befe",
        "#89dceb",
        "#a6d189",
        "#f4b8e4",
        "#f38ba8"
      ]
    },
    "chat": {
      "background": "#1e1e2e",
      "userMessage": "#cdd6f4",
      "userMessageBackground": "#383a4c",
      "assistantMessage": "#cdd6f4",
      "assistantMessageBackground": "#303142",
      "timestamp": "#abafc2",
      "divider": "#515468",
      "typing": "#abafc2"
    },
    "loading": {
      "spinner": "#b4befe",
      "spinnerTrack": "#303142",
      "skeleton": "#303142",
      "shimmer": "#484a5e"
    },
    "tools": {
      "background": "#303142",
      "border": "#515468",
      "headerHover": "#46485c",
      "icon": "#b4befe",
      "title": "#cdd6f4",
      "description": "#abafc2",
      "edit": {
        "added": "#a6d189",
        "addedBackground": "#a6d18924",
        "removed": "#f38ba8",
        "removedBackground": "#f38ba824",
        "modified": "#89dceb",
        "modifiedBackground": "#89dceb24",
        "lineNumber": "#abafc2"
      }
    },
    "markdown": {
      "heading1": "#cdd6f4",
      "heading2": "#cdd6f4",
      "heading3": "#cdd6f4",
      "heading4": "#cdd6f4",
      "link": "#b4befe",
      "linkHover": "#bdc6fe",
      "inlineCode": "#32db43",
      "inlineCodeBackground": "#303142",
      "blockquote": "#abafc2",
      "blockquoteBorder": "#515468",
      "listMarker": "#b4befebf",
      "bold": "#cdd6f4",
      "italic": "#cdd6f4e6",
      "strikethrough": "#abafc2",
      "hr": "#515468"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#ca7162",
        "foreground": "#000000",
        "contrast": 6.05
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#e0bda4",
        "foreground": "#000000",
        "contrast": 11.98
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ceae6a",
        "foreground": "#000000",
        "contrast": 9.89
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bed16f",
        "foreground": "#000000",
        "contrast": 12.54
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#ccdfac",
        "foreground": "#000000",
        "contrast": 14.72
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#6dcf6d",
        "foreground": "#000000",
        "contrast": 10.8
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#73c795",
        "foreground": "#000000",
        "contrast": 10.33
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#a7e3d0",
        "foreground": "#000000",
        "contrast": 14.54
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6cbfce",
        "foreground": "#000000",
        "contrast": 9.98
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6b98c2",
        "foreground": "#000000",
        "contrast": 6.9
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#607ec7",
        "foreground": "#000000",
        "contrast": 5.31
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#aea0dd",
        "foreground": "#000000",
        "contrast": 8.87
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8d68bf",
        "foreground": "#000000",
        "contrast": 4.86
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c666ca",
        "foreground": "#000000",
        "contrast": 6.15
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#ca64a2",
        "foreground": "#000000",
        "contrast": 5.86
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d78b9f",
        "foreground": "#000000",
        "contrast": 8.08
      }
    ]
  }
}
